import React, { Component } from "react";
import OwlCarousel from "react-owl-carousel";

import skillSetIcon from '../../../../images/SkillsetImage.png';

import navIcon from "../../../../images/nav-icon.svg";
const options = {
    margin: 15,
    nav: true,
    navText: [
        `<img src=${navIcon} />`,
        `<img src=${navIcon} />`,
    ],
    dots: false,
    responsive: {
        0: {
            items: 1,
        },
        600: {
            items: 3,
        },
        1000: {
            items: 4,
        },
    },
};

class Template extends Component {
    render() {
        return (
            <div className="ms-home tmp-rec-home scrollable">
                <div className="ms-home-outer">
                    <div className="ms-p1">
                        <div className="ms-title">
                            <span className="sm-tag">Create a Skill</span>
                            <h2>Recommend Template</h2>
                            <p>You have provided data in multiple fields during your show, how would you <br />like to input this data during automation?</p>
                        </div>
                    </div>
                    <div className="highlight-skill">
                        <div className="skill-big-box">
                            <img src={skillSetIcon} />
                        </div>
                        <div className="hgs-box">
                            <h3>Skill Template</h3>
                            <p>Save time with MIS reporting.<br /> Automatically download data from any web or desktop app…</p>
                            <button className="btn btn-dark btn-rounded">Use Now</button>
                        </div>
                    </div>
                    <div className="rct-slider">
                        <h4 className="rct-title">Other templates</h4>
                        <div className="rct-slider-block">
                            <OwlCarousel
                                className="owl-theme rct-owl-slider"
                                id="sk-boxes1"
                                {...options}
                            >
                                <div class="item rct-slide-item">
                                    <div class="rcs-outer">
                                        <div class="rcs-icon">
                                            <img src={skillSetIcon} alt="" />
                                        </div>
                                        <div class="rcs-content">
                                            <div class="rcs-inner-content">
                                                <h4 class="rcs-title">Skill Set</h4>
                                                <p class="rcs-text">Save time with MIS reporting. Automatically download data from any web or desktop app…</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item rct-slide-item">
                                    <div class="rcs-outer">
                                        <div class="rcs-icon">
                                            <img src={skillSetIcon} alt="" />
                                        </div>
                                        <div class="rcs-content">
                                            <div class="rcs-inner-content">
                                                <h4 class="rcs-title">Skill Set</h4>
                                                <p class="rcs-text">Save time with MIS reporting. Automatically download data from any web or desktop app…</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item rct-slide-item">
                                    <div class="rcs-outer">
                                        <div class="rcs-icon">
                                            <img src={skillSetIcon} alt="" />
                                        </div>
                                        <div class="rcs-content">
                                            <div class="rcs-inner-content">
                                                <h4 class="rcs-title">Skill Set</h4>
                                                <p class="rcs-text">Save time with MIS reporting. Automatically download data from any web or desktop app…</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item rct-slide-item">
                                    <div class="rcs-outer">
                                        <div class="rcs-icon">
                                            <img src={skillSetIcon} alt="" />
                                        </div>
                                        <div class="rcs-content">
                                            <div class="rcs-inner-content">
                                                <h4 class="rcs-title">Skill Set</h4>
                                                <p class="rcs-text">Save time with MIS reporting. Automatically download data from any web or desktop app…</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item rct-slide-item">
                                    <div class="rcs-outer">
                                        <div class="rcs-icon">
                                            <img src={skillSetIcon} alt="" />
                                        </div>
                                        <div class="rcs-content">
                                            <div class="rcs-inner-content">
                                                <h4 class="rcs-title">Skill Set</h4>
                                                <p class="rcs-text">Save time with MIS reporting. Automatically download data from any web or desktop app…</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="item rct-slide-item">
                                    <div class="rcs-outer">
                                        <div class="rcs-icon">
                                            <img src={skillSetIcon} alt="" />
                                        </div>
                                        <div class="rcs-content">
                                            <div class="rcs-inner-content">
                                                <h4 class="rcs-title">Skill Set</h4>
                                                <p class="rcs-text">Save time with MIS reporting. Automatically download data from any web or desktop app…</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </OwlCarousel>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
}

export default Template;